import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";

export const FileHandler = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { toast } = useToast();

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files || []);

    const allowedImageTypes = ["image/jpeg", "image/png", "image/gif"];
    const allowedVideoTypes = [
      "video/mp4",
      "video/quicktime",
      "video/x-msvideo",
      "video/x-matroska"
    ];

    const newImages = [];
    const newVideos = [];

    for (const file of files) {
      if (allowedImageTypes.includes(file.type)) {
        newImages.push(file);
      } else if (allowedVideoTypes.includes(file.type)) {
        newVideos.push(file);
      } else {
        toast({
          title: "Unsupported file ❌",
          description: `The file "${file.name}" is not a supported format. Please upload JPG, PNG, GIF (images) or MP4, MOV, AVI, MKV (videos).`,
          variant: "destructive"
        });
        e.target.value = "";
        return;
      }
    }

    const existingImages = selectedFiles.filter((f) =>
      allowedImageTypes.includes(f.type)
    );
    const existingVideos = selectedFiles.filter((f) =>
      allowedVideoTypes.includes(f.type)
    );

    const totalImageSize =
      existingImages.reduce((acc, f) => acc + f.size, 0) +
      newImages.reduce((acc, f) => acc + f.size, 0);

    const totalVideoSize =
      existingVideos.reduce((acc, f) => acc + f.size, 0) +
      newVideos.reduce((acc, f) => acc + f.size, 0);

    if (totalImageSize > 3 * 1024 * 1024) {
      toast({
        title: "Too many images 📸",
        description: "You can upload up to 3 MB of images in total.",
        variant: "destructive"
      });
      e.target.value = "";
      return;
    }

    if (totalVideoSize > 5 * 1024 * 1024) {
      toast({
        title: "Videos are too large 🎥",
        description: "Your videos together must be under 5 MB.",
        variant: "destructive"
      });
      e.target.value = "";
      return;
    }

    setSelectedFiles((prev) => [...prev, ...newImages, ...newVideos]);

    if (newImages.length > 0 || newVideos.length > 0) {
      const parts = [];

      if (newImages.length > 0) {
        parts.push(
          `${newImages.length} image${newImages.length > 1 ? "s" : ""}`
        );
      }

      if (newVideos.length > 0) {
        parts.push(
          `${newVideos.length} video${newVideos.length > 1 ? "s" : ""}`
        );
      }

      toast({
        title: "Files selected ✅",
        description: `${parts.join(" and ")} ready to upload.`
      });
    }

    e.target.value = "";
  };

  const removeFile = (indexToRemove) => {
    setSelectedFiles((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const clearFiles = () => {
    setSelectedFiles([]);
  };

  return {
    selectedFiles,
    handleFileSelect,
    removeFile,
    clearFiles
  };
};
